import { render } from "./ProjectsKanban.vue?vue&type=template&id=884193b4"
import script from "./ProjectsKanban.vue?vue&type=script&lang=js"
export * from "./ProjectsKanban.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__